import React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import {useTranslation} from "react-i18next";
import {Card, CardContent} from "framework7-react";

interface ChartPieComponentProps {
    currency?: string;
}

export const ChartPieComponent: React.FC <ChartPieComponentProps> = ({currency}) => {
    const {t} = useTranslation();
    const series = [1000, 4001, 3500];

    const options: ApexOptions = {
        chart: {
            type: 'donut',
            height: 250,
        },
        labels: ['Smartbet', 'Quickbet', 'Jackpot'],
        title: {
            text: t("dashboard.dailySales"),
        },
        plotOptions: {
            pie: {
                expandOnClick: false,
                donut: {
                    size: '60%',
                },
            },
        },
    };

    return(
        <Card>
            <CardContent>
                <Chart options={options} series={series} type="donut" height={250} />
            </CardContent>
        </Card>
    );
};
